module.exports = __webpack_public_path__ + "img/云存储3.196a1d10.jpg";